"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _hooks = require("../../hooks");

var _excluded = ["children", "className", "highlighted", "overlay", "thumbnail", "title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Card = function Card(_ref) {
  var children = _ref.children,
      className = _ref.className,
      highlighted = _ref.highlighted,
      overlay = _ref.overlay,
      thumbnail = _ref.thumbnail,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  var titleId = (0, _hooks.useId)();
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    "aria-labelledby": titleId,
    className: (0, _classnames.default)(className, {
      "p-card": !highlighted && !overlay,
      "p-card--highlighted": highlighted,
      "p-card--overlay": overlay
    }),
    role: "group"
  }, props), thumbnail && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
    className: "p-card__thumbnail",
    src: thumbnail,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("hr", {
    className: "u-sv1"
  })), title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "p-card__title",
    id: titleId
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "p-card__content"
  }, children));
};

var _default = Card;
exports.default = _default;